// Exports
export default {
	"content": "content_Mk6DX",
	"group": "group_z4XEG",
	"groupTitle": "groupTitle_mJJxC",
	"reasons": "reasons_vLXo5",
	"message": "message_OFiPS",
	"reason": "reason_tPvzw",
	"checked": "checked_3jQHD"
};
